import canUnitAnnexEntity from '../../entity/canUnitAnnexEntity'
import type { Entity } from '../../entity/index'
import type { AnnexableEntityList } from '../../state/AnnexableEntityList.type'
import type { EntityGridXYV2 } from '../EntityGridXYV2.type'
import getGridIndexListItemByXYOrThrow from '../GridIndex/getGridIndexListItemOrThrow'
import createLazyReadOnlyGridXY from '../createLazyReadOnlyGridXY'

export default function createLazyAnnexListGrid(
  // full state width
  gridWidth: number,
  // full state height
  gridHeight: number,
  // full state ents as GridXY
  grid: EntityGridXYV2,
  // unit attempting to enter a taxi
  unit: Entity
) {
  const lazyGrid = createLazyReadOnlyGridXY<AnnexableEntityList>(
    gridWidth,
    gridHeight,
    function annexableListGridGetter(x: number, y: number): AnnexableEntityList {
      const list : AnnexableEntityList = []
      const positionStack = getGridIndexListItemByXYOrThrow(gridWidth, gridHeight, grid, x, y)
      if (positionStack) {
        for (let index = 0; index < positionStack.length; index++) {
          const entity = positionStack[index];
          if (canUnitAnnexEntity(unit, entity)) {
            list.push(entity)
          }
        }
      }
      return list
    }
  )
  return lazyGrid
}
